import type {
  automaticProposalsRepository,
  HouseRepository,
} from 'lc-repository'
import Controller from './adapters/Controller'
import Presenter from './adapters/Presenter'

import {
  CreateAutomaticProposalCommentUseCase,
  GetAutomaticProposalsUseCase,
  ModifyAutomaticProposalCommentUseCase,
} from './usecases'
import type { UserRepositoryType } from '../../types'

export type AutomaticProposalsBuildType = {
  automaticProposalsRepository: ReturnType<typeof automaticProposalsRepository>
  housesRepository: ReturnType<typeof HouseRepository>
  userRepository: UserRepositoryType
}

export const automaticProposalsBuild = ({
  automaticProposalsRepository,
  housesRepository,
  userRepository,
}: AutomaticProposalsBuildType) => {
  const presenter = new Presenter()
  const controller = new Controller(
    {
      getAutomaticProposals: new GetAutomaticProposalsUseCase(
        automaticProposalsRepository,
        housesRepository,
      ),
      createAutomaticProposalComment: new CreateAutomaticProposalCommentUseCase(
        {
          createAutomaticProposalComment:
            userRepository.automaticProposal.automaticProposalComments
              .createAutomaticProposalComment,
        },
      ),
      modifyAutomaticProposalComment: new ModifyAutomaticProposalCommentUseCase(
        {
          modifyAutomaticProposalComment:
            userRepository.automaticProposal.automaticProposalComments
              .modifyAutomaticProposalComment,
        },
      ),
    },
    presenter,
  )

  return { controller, presenter }
}
